import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type OutageState = { code: 503 | null; errorDescription: string | null };

const initialState: OutageState = { code: null, errorDescription: null };

export const outageSlice = createSlice({
  name: 'outage',
  initialState,
  reducers: {
    setServiceUnavailable(state, action: PayloadAction<string | null | undefined>) {
      state.code = 503;
      state.errorDescription = action.payload ?? null;
    },
    clearOutage(state) {
      state.code = null;
      state.errorDescription = null;
    },
  },
});

export const { setServiceUnavailable, clearOutage } = outageSlice.actions;
